// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"e9624dee","453":"25f554ad","759":"f9b61fe5"}[chunkId] + ".chunk.js";
};